// 1) install p-limit: npm install p-limit
import pLimit from 'p-limit'
import { ALB_API_BASE_URL } from "./constants"
import { authFetch } from "./authFetch"

import { extractLeafNodeLabels } from '../components/InstrumentMenu'

const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
});

// break an array into chunks
function chunkArray(array, size) {
  const chunks = []
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size))
  }
  return chunks
}

// upload a single chunk; returns { total, success[], failed[], deleted[] }
async function uploadChunk(chunkSheets, chunkIndex, validInstrumentLabels) {
  // prepare JSONL
  const jsonl = await Promise.all(
    chunkSheets.map(async ({ sheet_id, original_data, original_path }) => {
      const data = await readFileAsBase64(original_data)
      return { sheet_id, original_data: data, original_path }
    })
  )

  // send to your existing uploadDriver
  const res = await authFetch(`${ALB_API_BASE_URL}/uploadDriver`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ jsonl, validInstrumentLabels }),
  })

  if (!res.ok) {
    const text = await res.text()
    console.error(`chunk ${chunkIndex} failed:`, text)
    // mark all as failed
    return {
      total: chunkSheets.length,
      success:[],
      failed: chunkSheets.map(s => s.sheet_id),
      deleted: [],
      errors: [`chunk ${chunkIndex} failed:` + text]
    }
  }

  return await res.json()
}

// the new chunked / parallel uploader
export async function uploadDriverInChunks({ sheets, onLoadingChange }) {
  if (onLoadingChange) onLoadingChange(true)

  // 0) get valid instrument labels
  const validInstrumentLabels = extractLeafNodeLabels();

  // 1) split into batches of 5 (tweak CHUNK_SIZE as you like)
  const CHUNK_SIZE = 5
  const MAX_CONCURRENCY = 10

  const chunks = chunkArray(sheets, CHUNK_SIZE)
  console.log(`Uploading ${sheets.length} sheets as ${chunks.length} chunks`)

  // 2) use p-limit to throttle to MAX_CONCURRENCY
  const limit = pLimit(MAX_CONCURRENCY)
  const tasks = chunks.map((chunk, i) =>
    limit(() => uploadChunk(chunk, i, validInstrumentLabels))
  )

  // 3) await all, then aggregate
  const results = await Promise.all(tasks)
  // console.log('upload FINAL RESULTS:', JSON.stringify(results, null, 2))
  const summary = results.reduce(
    (agg, r) => {
      agg.total   += r.total   || 0
      agg.success   .push(...(r.success   || []))
      agg.failed   .push(...(r.failed   || []))
      agg.deleted  .push(...(r.deleted  || []))
      agg.errors  .push(...(r.errors  || []))
      return agg
    },
    { total: 0, success: [], failed: [], deleted: [], errors: [] }
  )

  if (onLoadingChange) onLoadingChange(false)
  return summary
}
